export default {"src":"/_next/static/media/image-3-mob.b20bfc24.svg","height":204,"width":272,"blurWidth":0,"blurHeight":0};